<template>
  <LayoutProfile>
    <template v-slot:title>{{ $t('menu.password_change') }}</template>

    <article class="section-item">
      <header class="section-item__row">
        <div class="section-item__heading">
          <span class="section-item__heading__title">{{ $t('menu.password_change') }}</span>
        </div>
      </header>

      <div class="p-4">
        <div>
          <div class="d-lg-flex align-items-start justify-content-start">
            <div class="w-100 mb-4 mr-6">
              <label class="text-uppercase m-0 p-0 mb-2 px-3 small"
                     for="old_password">{{ $t('pages.profile_change_password.old_password') }}</label>
              <input-password v-model="old_password" :autocomplete="'new-password'" />
            </div>
            <div class="w-100 mb-4 mr-2">
              <label class="text-uppercase m-0 p-0 mb-2 px-3 small"
                     for="new_password1">{{ $t('pages.profile_change_password.new_password') }}</label>
              <input-password v-model="new_password1" :autocomplete="'new-password'" />
            </div>
            <div class="w-100 mb-4">
              <label class="text-uppercase m-0 p-0 mb-2 px-3 small"
                     for="new_password2">{{ $t('pages.profile_change_password.new_password_repeat') }}</label>
              <input-password v-model="new_password2" :autocomplete="'new-password'" />
            </div>
          </div>
        </div>
      </div>


      <footer class="section-item__footer">
        <div class="total-wrapper">
          <div class="items text-danger" v-if="passwordsFieldsRequiredError">
            {{ $t('pages.profile_change_password.password_fields_required_error') }}
          </div>
          <div class="items text-danger" v-if="passwordsNotMatchError">
            {{ $t('pages.profile_change_password.passwords_not_match_error') }}
          </div>
          <div class="items text-danger" v-for="(error, idx) in serverErrors" :key="idx">{{ error }}</div>
          <b-button variant="primary" class="ml-auto" @click="save()">
            {{ $t('pages.profile_change_password.action_save') }}
          </b-button>
        </div>
      </footer>
    </article>
  </LayoutProfile>
</template>


<script>
import UserService from "@/services/User.js"
import LayoutProfile from "@/components/LayoutProfile"
import InputPassword from "@/components/InputPassword";


export default {
  components: {
    InputPassword,
    LayoutProfile
  },

  data() {
    return {
      old_password: null,
      new_password1: null,
      new_password2: null,
      passwordsFieldsRequiredError: false,
      passwordsNotMatchError: false,
      serverErrors: []
    }
  },

  methods: {
    save() {
      this.passwordsFieldsRequiredError = false
      this.passwordsNotMatchError = false
      this.$set(this, 'serverErrors', [])

      if (!this.old_password || !this.new_password1 || !this.new_password2) {
        this.passwordsFieldsRequiredError = true
        return false
      }
      if (this.new_password1 !== this.new_password2)
        this.passwordsNotMatchError = true
      else {
        UserService.changePassword(this.old_password, this.new_password1, this.new_password2)
            .then(response => {
              console.log('response', response)
              this.$bvToast.toast(this.$t('notifications.password_changed'))
            })
            .catch(error => {
              if (error.response.status === 400) {
                this.$set(this, 'serverErrors', Object.values(error.response.data).flat())
              }
              return error
            })
      }
    }
  }
}
</script>
